const config = {
  contractAddress: '0x75774d5719a43237c9277654b1F8f525d5FFC2c8',
  tokenAddress:"0x4bA7EE92d3b29FC81AeE890F06C35b164414dfb0",
  maxTicketAmount: 100,
  
}

export { config }
